// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_57-0";
export var eligibilityCardNotEligible = "_57-1";